import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import classes from './PersonalForm.module.scss'
import { LOCALE_OPTIONS } from '../../../misc/Constants'
import { updateUserLocale, clearUserLocale } from '../../../actions/userActions'
import Select from '../../common/form/Select'

const LanguageForm = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const currentUser = useSelector(state => state.user.current_user)

  const [locale, setLocale] = useState(currentUser?.user_settings?.locale || '')
  const [isUpdating, setIsUpdating] = useState(false)

  const options = [{ value: '', label: t('account.language.useCommunityDefault') }, ...LOCALE_OPTIONS]
  const hasChanges = locale !== (currentUser?.user_settings?.locale || '')

  const handleSubmit = async e => {
    e.preventDefault()
    setIsUpdating(true)
    try {
      if (locale === '') {
        await dispatch(clearUserLocale(currentUser.id))
      } else {
        await dispatch(updateUserLocale(currentUser.id, locale))
      }
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className={classNames(classes.container, 'animated fadeIn')}>
      <div className='row mb-3'>
        <label htmlFor='locale'>{t('common.language')}</label>
        <p className={classNames('w-100 mb-2', classes.infoText)}>{t('account.language.languageHelp')}</p>
        <div className='w-100'>
          <Select
            inputId='locale'
            name='locale'
            value={options.find(option => option.value === locale)}
            options={options}
            onChange={option => setLocale(option.value)}
            isSearchable={false}
          />
        </div>
      </div>

      <div className='row mt-5'>
        <button
          type='submit'
          className='btn btn-primary'
          disabled={isUpdating || !hasChanges}
        >
          {isUpdating ? t('account.common.savingChanges') : t('common.action.saveChanges')}
        </button>
      </div>
    </form>
  )
}

export default LanguageForm
